module.exports = __webpack_public_path__ + "static/scale-model-of-riverfront-cruise-in-in-akron-ohio-34d29df7c84133ddd8b217fa342d864a.png";